module.exports = __webpack_public_path__ + "2020922:8e3d68e2a81bc56d01f1/img/Luminary-homepage-L-1024x576.2ac48ee.png";